import { modelHelperModule } from './model-helper';

export const invoiceModelModule = angular
  .module('Q.models.invoice', [modelHelperModule])

  .factory('Invoice', function (ModelHelper) {
    return ModelHelper.defineResource({
      name: 'Invoice',
      endpoint: 'invoices',

      relations: {
        belongsTo: {
          Team: {
            localField: 'team',
            localKey: 'teamId',
          },
        },
      },
      meta: {
        neverFetchOnPush: true,
      },
    });
  });
